export class PotenciaNaoEnviadaError extends Error {
  constructor() {
    super('Informe a potência dos painéis ou dos kits.');
  }
}
